import styles from './scss/inapp.module.scss';
import ContentLayout from '../../layout/contentLayout';
import { Link } from 'react-router-dom';
import { assets } from '../../styles/assets/assets';
import WorktualDropdown from '../../components/custom_components/WroktualDropdown';

const InApp = () => {
      const options = [
        {
            label: 'One', value: 'one'
        }
    ]
  return (
    <ContentLayout noPaddingBlock={true}>
      <div className='breadcrumbs'>
                <ol>
                    <li>
                        <Link to=''>Campaign Name</Link>
                    </li>
                    <li>Email </li>
                </ol>
            </div>
            <div className={styles.inappsec}>
                <div className={styles.mdflefts}>
                    <p>Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed</p>
                    <div className={styles.searchset}>
                        <input type="text" name="" id="" placeholder='Ask to edit' />
                        <img className={styles.searchlt} src={assets.search_icon} alt="search_icon" />
                        <img className={styles.closeic} src={assets.multi_close} alt="multi_close" />
                    </div>
                </div>
                <div className={styles.mdfrights}>
                     <div className={styles.headertxtgrp}>
                        <div className={styles.headerlefts}>
                        </div>
                        <div className={styles.headerrights}>
                             <p>A/B Test:</p>
                            <div className={styles.dropmenu}>
                                <WorktualDropdown onChange={() => { }} options={options}>
                                    <button className='cancelbtn'>Type A <img src={assets.chevrondown_icon} alt="chevrondown_icon" /></button>
                                </WorktualDropdown>
                            </div>
                        </div>
                    </div>
                    <div className={styles.prevsec}>
                        <div className={styles.previewshowsec}>
                            <div className={styles.mobilelayoutviewsec}>
                                <div className={styles.bodywrapper}>
                                    <div className={styles.mobileheader}>
                                        <img className={styles.topbarimg} src={assets.mobile_topbar} alt="topbarimg" />
                                        <img className={styles.camerafront} src={assets.camera_front} alt="camerafront" />
                                    </div>
                                    <div className={styles.mobilemainsec}>
                                        
                                    </div>
                                    <div className={styles.mobilefooter}>
                                        <img src={assets.message_bar} alt="messgagebottom" />
                                        <div className={styles.optionsbtm}>
                                            <span className={styles.optionsopen}></span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className={styles.btnsec}>
                            <button className='cancelbtn'>Cancel</button>
                            <button className='primarybtn'>Publish</button>
                        </div>
                    </div>
                </div>
            </div>
    </ContentLayout>
  )
}

export default InApp
